module.exports = __webpack_public_path__ + "img/44exp.a946167d.jpg";